import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
export var SearchApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(SearchApi, _BaseApi);

  var _super = _createSuper(SearchApi);

  function SearchApi() {
    _classCallCheck(this, SearchApi);

    return _super.apply(this, arguments);
  }

  return SearchApi;
}(BaseApi);
/**
 * autocomplete suggestions for search strings
 */

SearchApi.prototype.listAutocomplete = makeMethod({
  method: 'get',
  path: Request.Search.Paths.ListAutocomplete
});
/**
 * content (channel, video, etc) suggestions for given search string
 */

SearchApi.prototype.getContentSuggestion = makeMethod({
  method: 'get',
  path: Request.Search.Paths.GetContentSuggestion
});
/**
 * search results. paged
 */

SearchApi.prototype.search = makeMethod({
  method: 'get',
  path: Request.Search.Paths.Search
});